export const DISCOUNT = 'discount';
export const MARKUP = 'markup';
